"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _FormatPrice = require("../../../../utils/FormatPrice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-91piaj-0"
})(["text-align:", ";"], function (props) {
  return props.align;
});
var StrikethroughPrice = (0, _styledComponents["default"])(_pclnDesignSystem.Text).withConfig({
  componentId: "sc-91piaj-1"
})(["text-decoration:line-through;white-space:nowrap;"]);
var Price = (0, _styledComponents["default"])(_pclnDesignSystem.Text).withConfig({
  componentId: "sc-91piaj-2"
})(["line-height:32px;"]);
var Coupon = (0, _styledComponents["default"])(_pclnDesignSystem.Icon).withConfig({
  componentId: "sc-91piaj-3"
})(["background-color:", ";width:20px;height:20px;padding:3px;transform:scaleX(-1);position:absolute;left:-28px;top:6px;"], function (props) {
  return props.coupon === 'variant' ? '#ffcc00' : '#6600cc';
});
var PriceWrapper = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-91piaj-4"
})(["position:relative;"]);
var StyledPrice = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-91piaj-5"
})(["flex-direction:column;align-items:flex-end;white-space:nowrap;"]);

function PriceDisplay(_ref) {
  var className = _ref.className,
      title = _ref.title,
      prefixCurrencyText = _ref.prefixCurrencyText,
      suffixCurrencyText = _ref.suffixCurrencyText,
      price = _ref.price,
      strikethroughPrice = _ref.strikethroughPrice,
      totalPrice = _ref.totalPrice,
      timePeriod = _ref.timePeriod,
      align = _ref.align,
      coupon = _ref.coupon;
  var truncatedPrice = Math.floor(price);
  var truncatedStrikethroughPrice = Math.floor(strikethroughPrice);
  var strikethroughText = strikethroughPrice > 0 && "".concat(prefixCurrencyText).concat((0, _FormatPrice.formatPrice)(truncatedStrikethroughPrice), " ").concat(suffixCurrencyText);
  var formattedPrice = (0, _FormatPrice.formatPrice)(truncatedPrice);
  var totalText = "total: ".concat(prefixCurrencyText).concat(totalPrice).concat(suffixCurrencyText);

  var _useState = (0, _react.useState)('center'),
      _useState2 = _slicedToArray(_useState, 2),
      justify = _useState2[0],
      setJustify = _useState2[1];

  (0, _react.useEffect)(function () {
    if (align === 'left') {
      setJustify('flex-start');
    } else if (align === 'right') {
      setJustify('flex-end');
    }
  }, [align]);
  return _react["default"].createElement(Container, {
    className: className,
    alignItems: align,
    flexDirection: "column",
    justifyContent: justify
  }, title, strikethroughText && _react["default"].createElement(StrikethroughPrice, {
    fontSize: 1,
    color: "gray",
    bold: true
  }, "was ", strikethroughText), _react["default"].createElement(StyledPrice, {
    justifyContent: justify
  }, _react["default"].createElement(PriceWrapper, {
    alignItems: "center"
  }, coupon && _react["default"].createElement(Coupon, {
    coupon: coupon,
    name: "coupon",
    color: coupon === 'variant' ? 'black' : 'white'
  }), prefixCurrencyText && _react["default"].createElement(_pclnDesignSystem.Text, {
    mr: 1,
    fontSize: 1
  }, prefixCurrencyText), _react["default"].createElement(Price, {
    fontSize: 4,
    bold: true
  }, formattedPrice), suffixCurrencyText && _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1,
    ml: 1
  }, suffixCurrencyText)), timePeriod && _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1,
    color: "#5D6A7E",
    bold: true
  }, "per ", timePeriod)), _react["default"].createElement(_pclnDesignSystem.Flex, null, totalPrice > 0 && _react["default"].createElement(_pclnDesignSystem.Text, {
    color: "#697886",
    fontSize: 1
  }, totalText)));
}

PriceDisplay.displayName = 'PriceDisplay';
PriceDisplay.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].node,
  prefixCurrencyText: _propTypes["default"].string,
  suffixCurrencyText: _propTypes["default"].string,
  price: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  strikethroughPrice: _propTypes["default"].number,
  totalPrice: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  timePeriod: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(['left', 'center', 'right']),
  coupon: _propTypes["default"].string
};
PriceDisplay.defaultProps = {
  className: '',
  prefixCurrencyText: '$',
  suffixCurrencyText: '',
  align: 'center',
  coupon: ''
};

var _default = (0, _react.memo)(PriceDisplay);

exports["default"] = _default;